export default {
    oidc: {
      useInteractionCodeFlow: false,
      useClassicEngine: true,
      issuer: process.env.REACT_APP_OKTA_ISSUER_URL,
      clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
      scopes: ['openid', 'profile', 'email', 'phone'],
      redirectUri: window.location.origin + '/authorization-code/callback'
    },
    widget: {
      useInteractionCodeFlow: false,
      useClassicEngine: true,
      issuer: process.env.REACT_APP_OKTA_ISSUER_URL,
      clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
      redirectUri: window.location.origin + '/authorization-code/callback',
      scopes: ['openid', 'profile', 'email', 'phone'],
    }
  };